import React from 'react';

import { StyledAutocomplete, StyledTextField } from 'components/Input/styles';

import { COUNTRIES, Country } from './countries';

export interface CountrySelectProps {
  value: string | null;
  onChange: (code: string) => void;
  error?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
}

const CountrySelect: React.FunctionComponent<CountrySelectProps> = ({
  value,
  onChange,
  error,
  disabled,
  fullWidth = true,
}) => {
  const selected = value ? (COUNTRIES.find((country) => country.code === value) ?? null) : null;

  return (
    <StyledAutocomplete
      fullWidth={fullWidth}
      disabled={disabled}
      options={COUNTRIES}
      value={selected}
      getOptionLabel={(option: Country) => option.name}
      isOptionEqualToValue={(option: Country, selectedOption: Country) => option.code === selectedOption.code}
      onChange={(_, option) => onChange((option as Country | null)?.code ?? '')}
      renderInput={(params) => <StyledTextField {...params} error={error} placeholder="Select country" />}
    />
  );
};

export default CountrySelect;
